export default __webpack_public_path__ + "static/6-d77d1b89688e1349130eb80d97398460.png";